/**
 * Send analytics event of page view only if pathname has changed
 */
'use client';

import { useEffect, useRef } from 'react';

import { useAnalyticsEvents } from '@/hooks/use-analytics-events';
import { usePathname } from '@/i18n/navigation';

export function usePageViewTracking() {
  const pathname = usePathname();
  const { trackPageView } = useAnalyticsEvents();
  const previousPathnameRef = useRef<string>('');

  useEffect(() => {
    if (previousPathnameRef.current !== pathname) {
      trackPageView(pathname);
      previousPathnameRef.current = pathname;
    }
  }, [pathname, trackPageView]);
}
